var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAzerbaijan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_32993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 10.5322 23.736 9.12605 23.2536 7.82612L12 7.30435L0.746391 7.82607C0.264047 9.12605 0 10.5322 0 12C0 13.4679 0.264047 14.874 0.746391 16.1739L12 16.6957L23.2536 16.1739C23.736 14.874 24 13.4679 24 12Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 24C17.1593 24 21.5578 20.7435 23.2533 16.1739H0.746094C2.44161 20.7435 6.84012 24 11.9997 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0C6.84013 0 2.44161 3.2565 0.746094 7.82611Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2605 15.3913C10.3875 15.3913 8.86915 13.8729 8.86915 12C8.86915 10.127 10.3875 8.60867 12.2605 8.60867C12.8444 8.60867 13.3939 8.75633 13.8737 9.0163C13.121 8.28032 12.0919 7.82605 10.9561 7.82605C8.6509 7.82605 6.78223 9.69477 6.78223 11.9999C6.78223 14.3051 8.65095 16.1738 10.9561 16.1738C12.0919 16.1738 13.1211 15.7196 13.8737 14.9836C13.3939 15.2436 12.8444 15.3913 12.2605 15.3913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8693 9.65216L15.3185 10.9155L16.5295 10.3398L15.9538 11.5507L17.2171 12L15.9538 12.4492L16.5295 13.6602L15.3185 13.0845L14.8693 14.3478L14.4202 13.0845L13.2091 13.6602L13.7849 12.4492L12.5215 12L13.7849 11.5507L13.2091 10.3398L14.4202 10.9155L14.8693 9.65216Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_32993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/23c9918a.svg";
export { SvgAzerbaijan as ReactComponent };